/*
The slide's size is defined by the equation: size = 1 - TWEEN_FACTOR_BASE,
each increase in the tween factor subtracts directly from its full, original size.
 */
const TWEEN_FACTOR_BASE = 0.18
let tweenFactor = 0
let tweenNodes = []
let tweenNodesContent = []

/**
 * https://www.embla-carousel.com/api/methods/
 *
 * TWEEN_FACTOR_BASE is a constant that determines the strength of the tween effect.
 *
 * emblaApi.slideNodes() -> HTMLElement[]
 * emblaApi.slidesInView() -> number[] (Get slide indexes visible in the carousel viewport)
 * emblaApi.scrollProgress() -> number (Check how far the carousel has scrolled of its scrollable length from 0 - 1.)
 *
 * emblaApi.scrollSnapList() -> number[] (Get an array containing all the snap point positions.
 * Each position represents how far the carousel(slide) needs to progress in order to reach this position.)
 */

const numberWithinRange = (number, min, max) =>
    Math.min(Math.max(number, min), max)

const setTweenNodes = (emblaApi) => {
    tweenNodes = emblaApi.slideNodes().map((slideNode) => {
        return slideNode.querySelector('.embla__slide__number')
    })

    tweenNodesContent = emblaApi.slideNodes().map((slideNode) => {
        return slideNode.querySelector('.embla__slide__content')
    })
}

const setTweenFactor = (emblaApi) => {
    tweenFactor = TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length
}

const tweenScale = (emblaApi, eventName) => {
    const engine = emblaApi.internalEngine()
    const scrollProgress = emblaApi.scrollProgress()
    const slidesInView = emblaApi.slidesInView()
    const isScrollEvent = eventName === 'scroll';

    emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
        let diffToTarget = scrollSnap - scrollProgress
        const slidesInSnap = engine.slideRegistry[snapIndex]


        slidesInSnap.forEach((slideIndex) => {
            if (isScrollEvent && !slidesInView.includes(slideIndex)) return

            if (engine.options.loop) {
                engine.slideLooper.loopPoints.forEach((loopItem) => {
                    const target = loopItem.target()

                    if (slideIndex === loopItem.index && target !== 0) {
                        const sign = Math.sign(target)

                        if (sign === -1) {
                            diffToTarget = scrollSnap - (1 + scrollProgress)
                        }
                        if (sign === 1) {
                            diffToTarget = scrollSnap + (1 - scrollProgress)
                        }
                    }
                })
            }

            const tweenValue = 1 - Math.abs(diffToTarget * tweenFactor);
            // 0.8 is hardcoded as the threshold to keep all children with the same size, the default is 0
            const scale = numberWithinRange(tweenValue, 0.8, 1).toString();
            const tweenNode = tweenNodes[slideIndex];
            tweenNode.style.transform = `scale(${scale})`;

            // Note: the content is visible with this transition. if we keep this the scale of the whole component
            // will be affected. This content (tweenContent) is not part as the default EmblaCarousel component

            const opacityInterpolation = ( (tweenValue - 0.75) / 0.25 ); // bc 0.75 is the threshold for opacity to start fading out
            const tweenContent = tweenNodesContent[slideIndex];
            // We reapply the same logic as the scale to the opacity, it's like a fade out effect over 0.25
            tweenContent.style.opacity = opacityInterpolation >= 0.75 ? ((opacityInterpolation - 0.75) / 0.25) : 0;
            // tweenContent.style.transform = `translateX(-50%) scale(${opacity})`;
            // gray filter on tweenNode
            tweenNode.style.setProperty('--life-filter-gray', opacityInterpolation >= 0.7 ? 1 - opacityInterpolation : 1);
        })
    })
}

export const setupTweenScale = (emblaApi) => {
    setTweenNodes(emblaApi)
    setTweenFactor(emblaApi)
    tweenScale(emblaApi)

    emblaApi
        .on('reInit', setTweenNodes)
        .on('reInit', setTweenFactor)
        .on('reInit', tweenScale)
        .on('scroll', tweenScale)
        .on('slideFocus', tweenScale)

    return () => {
        tweenNodes.forEach((slide) => slide.removeAttribute('style'))
    }
}
